import { ApiClient } from '@/shared/api/client';
import type { HowtoDoc, HowtoDocInput, HowtoDocSummary, HowtoFile } from '@/features/howto/types';

export const howtoApi = {
  list: () => ApiClient.getJson<{ docs: HowtoDocSummary[] }>('/howto/docs'),
  get: (id: number) => ApiClient.getJson<HowtoDoc>(`/howto/docs/${id}`),
  create: (input: HowtoDocInput) => ApiClient.postJson<HowtoDoc>('/howto/docs', input),
  update: (id: number, input: HowtoDocInput) => ApiClient.patchJson<HowtoDoc>(`/howto/docs/${id}`, input),
  remove: (id: number) => ApiClient.deleteJson<{ removed: true }>(`/howto/docs/${id}`),
  upload: (file: File) =>
    ApiClient.postFile<HowtoFile>(
      `/howto/files?name=${encodeURIComponent(file.name || 'file')}&type=${encodeURIComponent(file.type || 'application/octet-stream')}`,
      file,
    ),
};
